
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/italian",
      function () {
        return require("private-next-pages/italian.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/italian"])
      });
    }
  